export enum Flow {
    ADD_CARD = 'add_card',
    REPLACE_CARD = 'replace_card',
}
